<template>
  <div class="print-d2" v-loading="loading">
    <div v-for="(e,i) in data.Halls" :key="i" class="main" :style="i>0?'page-break-before:always;':''">
      <div :key="'t'+i" class="no-print">
        <div class="examName">
          汕头金中海湾学校“天文地理特长生”{{year}}年自主招生考试座位表
        </div>
        <div class="examInfo">
          考点：{{data.ExamPlace}}
          <div class="place">考场号：{{e.ExamHallNo}}</div>
        </div>
      </div>
      <template v-for="(item,index) in e.Students">
        <div :key="'p'+index" v-if="index==0" class="break">
          <div class="examName">
            汕头金中海湾学校“天文地理特长生”{{year}}年自主招生考试座位表
          </div>
          <div class="examInfo">
            考点：{{data.ExamPlace}}
            <div class="place">考场号：{{e.ExamHallNo}}</div>
          </div>
        </div>
        <div class="item" :key="index" :class="{ 'bt': index<6, 'bl': (index+1)%6==1, 'bt2': index%42<6 }">
          <div>
            <el-image :src="'/api'+item.PicUrl" fit="cover" :preview-src-list="['/api'+item.PicUrl]" />
          </div>
          <div>
            座位号 {{item.SeatNo}}
            <span style="float:right;">{{item.AdmissionNo}}</span>
          </div>
          <div>
            姓名 {{item.FullName}}
            <span style="float:right;">{{item.Sex==1?"男":"女"}}</span>
          </div>
        </div>
        <div :key="'p'+index" v-if="(index+1)%42==0 && index < e.Students.length-1" class="break" style="page-break-before:always;">
          <div class="examName">
            汕头金中海湾学校“天文地理特长生”{{year}}年自主招生考试座位表
          </div>
          <div class="examInfo">
            考点：{{data.ExamPlace}}
            <div class="place">考场号：{{e.ExamHallNo}}</div>
          </div>
        </div>
      </template>
    </div>
    <div class="handle-button no-print">
      <el-button icon="el-icon-printer" size="mini" type="primary" @click="print">打印</el-button>
    </div>
  </div>
</template>
<script>
const date = new Date();
const year = date.getFullYear();
export default {
  beforeMount() {
    this.loading = true;
    var id = this.$route.query.id;
    this.api.getExamPlace(id).then(res => {
      this.loading = false;
      if (res.Code == 0) {
        // res.Data.Halls[0].Students = res.Data.Halls[0].Students.concat(res.Data.Halls[0].Students);
        // res.Data.Halls[0].Students = res.Data.Halls[0].Students.concat(res.Data.Halls[0].Students);
        // res.Data.Halls[0].Students = res.Data.Halls[0].Students.concat(res.Data.Halls[0].Students);
        // res.Data.Halls[0].Students = res.Data.Halls[0].Students.concat(res.Data.Halls[0].Students);
        // res.Data.Halls[0].Students = res.Data.Halls[0].Students.concat(res.Data.Halls[0].Students);
        // res.Data.Halls[0].Students = res.Data.Halls[0].Students.concat(res.Data.Halls[0].Students);
        this.data = res.Data;
      } else this.$message.error(res.Msg);
    });
  },
  data() {
    return {
      api: require("@/api/po/exam").default,
      data: {
        Halls: [],
        ExamPlace: "",
      },
      year,
      loading: false
    };
  },
  methods: {
    print() {
      window.print();
    }
  }
};
</script>
<style lang="scss" scoped>
.print-d2 {
  width: 740px;
  margin: 20px auto 20px;
  .main {
    margin-bottom: 20px;
  }
  .examName {
    text-align: center;
    font-size: 24px;
    font-family: '宋体','微软雅黑';
  }
  .examInfo {
    font-family: '宋体','微软雅黑';
    font-size: 16px;
    position: relative;
    margin: 15px 0 10px;
    .place {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .item {
    display: inline-block;
    font-size: 12px;
    height: 145px;
    line-height: 2;
    width: 16.66%;
    // width: 20%;
    border: 2px solid #000;
    border-left-width: 0;
    border-top-width: 0;
    padding: 10px 6px 0;
    box-sizing: border-box;
    .el-image {
      margin: 0 auto 5px;
      display: block;
      height: 78px;
      width: 66px;
      // border: 1px solid #000;
    }
  }
  .handle-button {
    position: fixed;
    top: 10px;
    right: 30px;
  }
  .nextPage {
    page-break-after: always !important;
  }
  .bt {
    border-top-width: 2px !important;
  }
  .bl {
    border-left-width: 2px !important;
  }
  .break {
    display: none;
  }
}
@media print {
  .main {
    margin-bottom: 0;
    padding: 0 36px;
  }
  .print-d2 {
    width: 100%;
    margin: 0;
  }
  .examName {
    padding-top: 15px;
  }
  .item {
    // height: 190px;
  }
  .break {
    display: block !important;
  }
  .bt2 {
    border-top-width: 2px !important;
  }
  .no-print {
    display: none;
  }
}
</style>